var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serviceMessage)?_c('v-container',{staticClass:"mr-5 justify-center",attrs:{"width":"100%"}},[_c('v-alert',{attrs:{"variant":"tonal","density":"comfortable","type":"warning"}},[_vm._v(" "+_vm._s(_vm.serviceMessage)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }